import { render, staticRenderFns } from "./ProductoCategoria.vue?vue&type=template&id=e470976e&"
import script from "./ProductoCategoria.vue?vue&type=script&lang=js&"
export * from "./ProductoCategoria.vue?vue&type=script&lang=js&"
import style0 from "./ProductoCategoria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports